class FtConfig{
    readonly cssPrefix='ft-'
}
export default new FtConfig();